// Typelizer digest f7cec5ed4b461feacb968858d22bdc7d
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from './runtime'
import { buildUrl } from './runtime'

export default {
  /** GET /centers/export_excel */
  exportExcel: (options?: RouteOptions): RouteDefinition<'get'> => ({
    url: buildUrl('/centers/export_excel', {}, options),
    method: 'get',
  }),

  /** GET /centers */
  index: (options?: RouteOptions): RouteDefinition<'get'> => ({
    url: buildUrl('/centers', {}, options),
    method: 'get',
  }),

  /** POST /centers */
  create: (options?: RouteOptions): RouteDefinition<'post'> => ({
    url: buildUrl('/centers', {}, options),
    method: 'post',
  }),

  /** GET /centers/new */
  new: (options?: RouteOptions): RouteDefinition<'get'> => ({
    url: buildUrl('/centers/new', {}, options),
    method: 'get',
  }),

  /** GET /centers/:id/edit */
  edit: (
    params: { id: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'get'> => ({
    url: buildUrl('/centers/:id/edit', params, options),
    method: 'get',
  }),

  /** GET /centers/:id */
  show: (
    params: { id: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'get'> => ({
    url: buildUrl('/centers/:id', params, options),
    method: 'get',
  }),

  /** PATCH /centers/:id */
  update: (
    params: { id: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'patch'> => ({
    url: buildUrl('/centers/:id', params, options),
    method: 'patch',
  }),

  /** DELETE /centers/:id */
  destroy: (
    params: { id: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'delete'> => ({
    url: buildUrl('/centers/:id', params, options),
    method: 'delete',
  }),
}
